import React, { useState } from 'react';
import Logo from '../../assests/logo.svg';
import DoorIcon from '../../assests/doorIcon.svg';
import { IoMdMenu } from 'react-icons/io';
import { IoClose } from 'react-icons/io5';
import { Dropdown, Menu, Button } from 'components/ui';
import { Link } from 'react-router-dom';
import { useHeader } from './talons/useHeader.js';
import { useNavigate } from 'react-router-dom';
import { Container } from 'components/shared';
import UserDropdown from 'components/template/UserDropdown';
import useAuth from 'utils/hooks/useAuth';

const HeaderMobile = ({ isOpen, setIsOpen, specialties }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  return (
    <div className="absolute z-50 w-full h-full -top-0 right-0 bg-white">
      <div className="p-8">
        <div className="flex justify-between items-center mb-4">
          <h4>Menu</h4>
          <IoClose size={32} onClick={() => setIsOpen(false)} />
        </div>
        <Menu>
          {/* <Menu.MenuCollapse eventKey="item-2" label="Serviços" onToggle={handleToggle}>
            {specialties &&
              specialties.map((item) => {
                return (
                  <Menu.MenuItem>
                    <Link className="menu-item-link" to={`/results/${item.specialty}`}>
                      {item.specialty}
                    </Link>
                  </Menu.MenuItem>
                );
              })}
          </Menu.MenuCollapse> */}
          <Menu.MenuItem eventKey="item-2">
            <Link className="menu-item-link" to="/results/Cirúrgica">
              Marcar consulta
            </Link>
          </Menu.MenuItem>
          <Menu.MenuItem eventKey="item-3">
            <Link className="menu-item-link" to="/sign-up?type=doctor">
              Médicos
            </Link>
          </Menu.MenuItem>
          <Menu.MenuItem eventKey="item-4">
            <Link className="menu-item-link" to="/">
              FAQ
            </Link>
          </Menu.MenuItem>
          <Menu.MenuItem eventKey="item-5">
            <Link className="menu-item-link" to="/">
              Contatos
            </Link>
          </Menu.MenuItem>
        </Menu>

        <Button
          size="md"
          variant="solid"
          onClick={() => navigate('/sign-in')}
          className="flex items-center justify-center gap-2 w-full mt-4"
        >
          <img src={DoorIcon} alt="Logotipo do App" />
          <p className="text-orange-50 text-base font-bold leading-normal">Entrar</p>
        </Button>
      </div>
    </div>
  );
};

const Header = ({ children, content, ...rest }) => {
  const { specialties } = useHeader();
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const { authenticated } = useAuth();

  return (
    <div className="h-20 py-4 px-4 bg-white shadow flex-col justify-center items-center gap-2 inline-flex">
      <Container>
        <div className="w-full flex justify-between items-center inline-flex">
          <div
            className="justify-start items-center gap-2 flex"
            onClick={() => navigate('/')}
          >
            <Link to={'/'}>
              <img src={Logo} alt="Logotipo do App" className="w-[190px] object-cover" />
            </Link>
          </div>
          <div className="justify-start items-center gap-6 flex">
            <div className="block lg:hidden">
              <IoMdMenu size={32} onClick={() => setIsOpen(true)} />
              <HeaderMobile
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                specialties={specialties}
              />
            </div>

            <div className="justify-center items-center gap-8 hidden lg:flex">
              {/* <div className="justify-start items-center flex text-stone-600 text-base font-medium leading-normal">
                <Dropdown title="Serviços" className="mr-2">
                  {specialties &&
                    specialties.map((item) => {
                      return (
                        <Dropdown.Item>
                          <Link
                            className="menu-item-link"
                            to={`/results/${item.specialty}`}
                          >
                            {item.specialty}
                          </Link>
                        </Dropdown.Item>
                      );
                    })}
                </Dropdown>
              </div> */}
              {/* <Link
                className="text-stone-600 text-base font-medium leading-normal"
                to="/sign-up?type=doctor"
              >
                Médicos
              </Link> */}
              {/* <Link
                className="text-stone-600 text-base font-medium leading-normal"
                to="/"
              >
                FAQ
              </Link>
              <Link
                className="text-stone-600 text-base font-medium leading-normal"
                to="/"
              >
                Contato
              </Link> */}
            </div>

            {/* <Button
              size="md"
              variant="solid"
              onClick={() => navigate('/results/Cirúrgica')}
              className="flex items-center justify-center gap-2 w-full"
            >
              <Link to={'/'}>
                <img src={DoorIcon} alt="Logotipo do App" />
              </Link>
              <p className="text-orange-50 text-base font-bold leading-normal">
                Marcar consulta
              </p>
            </Button> */}

            {authenticated ? (
              <UserDropdown />
            ) : (
              <div className="flex items-center gap-6">
                {/* <p className="hidden md:flex whitespace-nowrap text-lg text-black">
                  CADASTROS
                </p> */}
                <Button
                  size="md"
                  variant="solid"
                  onClick={() => {
                    localStorage?.removeItem('checkoutUrl');
                    navigate('/sign-in');
                  }}
                  className="hidden md:flex items-center justify-center gap-2 w-full"
                >
                  <Link to={'/'}>
                    <img src={DoorIcon} alt="Logotipo do App" />
                  </Link>
                  <p className="text-orange-50 text-base font-bold leading-normal">
                    Acessar ou Criar Conta
                  </p>
                </Button>
              </div>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Header;
